import { TrashIcon } from '@heroicons/react/24/outline'

interface ButtonGroupProps {
  /**
   * Title of Input
   */
  title?: Array<string> | Record<string, string>
  /**
   * Value of Input
   */
  value?: string
  /**
   * Custom class name
   */
  className?: string
  sort?: boolean
  hasRemove?: boolean
  onChange?: (checked: any) => void
  onRemove?: (value: any) => void
}

/**
 * Primary UI component for user interaction
 */
export const ButtonGroup = ({
  title = [],
  value = '',
  className = '',
  onChange = () => {},
  onRemove = () => {},
  sort = false,
  hasRemove = false,
  ...props
}: ButtonGroupProps) => {
  let keyArr = []
  if (Array.isArray(title)) keyArr = title
  else keyArr = Object.keys(title)

  if (sort) keyArr = keyArr.sort()
  return (
    <div className="inline-flex rounded-md shadow-sm p-2 flex-wrap" {...props}>
      {Array.isArray(title) &&
        keyArr.map((t, index) => {
          const classes = [
            'py-2 px-4 text-sm font-medium bg-white border-r border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white cursor-pointer',
          ]
          const isActive = value == t
          const isFirst = index == 0
          const isLast = index == title.length - 1

          if (isActive) classes.push('text-shade-blue ring-shade-blue ring-2 z-10')
          else classes.push('')

          if (isFirst) classes.push('rounded-l border')
          if (isLast) classes.push('rounded-r border')
          if (!isFirst && !isLast) classes.push('border-t border-b')

          classes.push(className)

          return (
            <a aria-current="page" className={classes.join(' ')} onClick={() => onChange(t)} key={`${title}-${index}`}>
              <div className="flex justify-center items-center gap-2">
                {hasRemove && (
                  <TrashIcon
                    className="h-3.5 w-3.5 hover:text-red-500 hover:cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      onRemove(t)
                    }}
                  />
                )}
                <span>{t}</span>
              </div>
            </a>
          )
        })}

      {!Array.isArray(title) &&
        keyArr.map((key, index) => {
          const classes = [
            'py-2 px-4 text-sm font-medium bg-white border-r border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white cursor-pointer',
          ]
          const isActive = value == key
          const isFirst = index == 0
          const isLast = index == Object.keys(title).length - 1

          if (isActive) classes.push('text-shade-blue ring-shade-blue ring-2 z-10')
          else classes.push('')

          if (isFirst) classes.push('rounded-l border')
          if (isLast) classes.push('rounded-r border')
          if (!isFirst && !isLast) classes.push('border-t border-b')

          classes.push(className)

          return (
            <a
              aria-current="page"
              className={classes.join(' ')}
              onClick={() => onChange(key)}
              key={`${title}-${index}`}
            >
              <div className="flex justify-center items-center gap-2">
                {hasRemove && (
                  <TrashIcon
                    className="h-3.5 w-3.5 hover:text-red-500 hover:cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      onRemove(key)
                    }}
                  />
                )}
                <span>{title[key]}</span>
              </div>
            </a>
          )
        })}
    </div>
  )
}
